import { render, staticRenderFns } from "./AssemblyCreate.vue?vue&type=template&id=116cf6dc"
import script from "./AssemblyCreate.vue?vue&type=script&lang=js"
export * from "./AssemblyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports